import { URL_ORIGIN } from "./MetaTagsConstants";

export const HOME_WIDGET_STORY_LIMIT = 3;

export const TRANSLATION_CONTACT_US_EMAIL = "priyaav@sph.com.sg";
export const TRANSLATION_CONTACT_US_PHONE = "(65) 6319 4062";

// The below enum is used to define the SSR regenerate interval for pages. The values are in seconds.
export const REGENERATE_INTERVAL: Record<string, number> = {
  ONE_HOUR: 60 * 60,
  ONE_DAY: 24 * 60 * 60,
  THREE_DAYS: 3 * 24 * 60 * 60,
  ONE_WEEK: 7 * 24 * 60 * 60,
};

// The below enum cloudfront cache control max age for SSR pages. The values are in seconds.
// 5 mins, 30 mins, 1 hour, 6 hours
export const CLOUDFRONT_CACHE_MAX_AGE: Record<string, number> = {
  FIVE_MINUTES: 5 * 60,
  THIRTY_MINUTES: 30 * 60,
  ONE_HOUR: 60 * 60,
  SIX_HOURS: 6 * 60 * 60,
};

export const GOOGLE_PREFERED_SOURCES_LINK = `https://www.google.com/preferences/source?q=${URL_ORIGIN}`;
